import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import {AppStore} from "../../../stores/app.store";
import SanitizeHTML from "../../../sanitize-html/sanitize.html";

export type ReportTaxonomyDescriptionProps = {
	taxonomyId: string;
	appStore?: AppStore;
};

const separateTextByLineBrake = (taxonomyText: string) => {
	return taxonomyText.split("\n").filter((tt) => tt !== "");
};

export const ReportTaxonomyDescription = useAppStore()(({taxonomyId, appStore}: ReportTaxonomyDescriptionProps) => {
	const store = appStore!.reportPageStore;
	const taxonomy = store.questionnaireAnswerSheetDetails.taxonomyTexts.find((tt) => tt.taxonomyId === taxonomyId);

	if (!taxonomy) {
		return null;
	}

	const separatedText = separateTextByLineBrake(taxonomy.text);
	const classNames = `cih-report-block cih-avoid-pg-break cih-${taxonomy.taxonomy.toLowerCase()}`;

	return (
		<div className={classNames}>
			<div className="cih-report-result">
				{separatedText.map((st) => (
					<p key={st}>{<SanitizeHTML html={st} />}</p>
				))}
			</div>
		</div>
	);
});
